<avs-datagrid
  (sortChange)="gridSort.set($event)"
  [columnOrder]="columnOrder"
  [columns]="columns"
  [hasMore]="false"
  [isLoading]="false"
  [noDataText]="noDataText()"
  [resizableColumns]="true"
  [rows]="rows()"
  [sort]="gridSort()"
  [tableId]="tableId()"
  [trackBy]="trackById"
  [zoomControls]="true"
>
  <ng-template
    avsCell="index"
    let-index="index"
  >{{ index + 1 }}</ng-template>

  <ng-template
    avsCell="ticketNumber"
    let-row
  >
    <span class="test-ticket-number">{{ row.ticketNumber }}</span>
  </ng-template>

  <ng-template
    avsCell="status"
    let-row
  >
    <div class="flex gap-1">
      <avs-incident-severity-icon [severity]="row.severity" />
      <span class="capitalize">{{ row.severity }}</span>
    </div>
  </ng-template>

  <ng-template
    avsCell="deviceId"
    let-row
  >
    <span>
      @if (row.isNetworkPort) {
        <div>{{ row.parentName }}</div>
      }
      <div>{{ row.deviceName }}</div>
    </span>
  </ng-template>

  <ng-template
    avsCell="deviceType"
    let-row
  >{{ row.deviceType }}</ng-template>

  <ng-template
    avsCell="building"
    let-row
  >{{ row.building }}</ng-template>

  <ng-template
    avsCell="floor"
    let-row
  >{{ row.floor }}</ng-template>

  <ng-template
    avsCell="room"
    let-row
  >{{ row.room }}</ng-template>

  <ng-template
    avsCell="reported"
    let-row
  >{{ row.reported }}</ng-template>

  <ng-template
    avsCell="incidentRule"
    let-row
  >{{ row.incidentRule || '-' }}</ng-template>

  <ng-template
    avsCell="resolved"
    let-row
  >{{ row.resolved || '-' }}</ng-template>
</avs-datagrid>
